/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_st_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For 2, 4, 4, 4, 5, 5, 7, 9 the mean is 5 and the mode is 4.`)
};

const es_st_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para 2, 4, 4, 4, 5, 5, 7, 9 la media es 5 y la moda es 4.`)
};

const de_st_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für 2, 4, 4, 4, 5, 5, 7, 9 beträgt der Mittelwert 5 und der Modus 4.`)
};

const nl_st_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voor 2, 4, 4, 4, 5, 5, 7, 9 is het gemiddelde 5 en de modus 4.`)
};

const fr_st_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour 2, 4, 4, 4, 5, 5, 7, 9, la moyenne est 5 et le mode est 4.`)
};

const it_st_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per 2, 4, 4, 4, 5, 5, 7, 9 la media è 5 e la moda è 4.`)
};

const pt_br2_st_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para 2, 4, 4, 4, 5, 5, 7, 9 a média é 5 e a moda é 4.`)
};

const pt_st_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para 2, 4, 4, 4, 5, 5, 7, 9 a média é 5 e a moda é 4.`)
};

const ja_st_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2, 4, 4, 4, 5, 5, 7, 9の場合、平均値は5、最頻値は4です。`)
};

const zh_st_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对于 2, 4, 4, 4, 5, 5, 7, 9 这组数据，平均数为 5，众数为 4。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const st_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.st_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("st_ex1", locale)
	if (locale === "en") return en_st_ex1(inputs)
	if (locale === "es") return es_st_ex1(inputs)
	if (locale === "de") return de_st_ex1(inputs)
	if (locale === "nl") return nl_st_ex1(inputs)
	if (locale === "fr") return fr_st_ex1(inputs)
	if (locale === "it") return it_st_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_st_ex1(inputs)
	if (locale === "pt") return pt_st_ex1(inputs)
	if (locale === "ja") return ja_st_ex1(inputs)
	return zh_st_ex1(inputs)
};